import * as yup from 'yup'

export class VehicleInvoicingDto {
  // VTS2 T&M Support - 25939: R02 - Inspection Company Card & Edit Invoicing Information Dialog Updates - Design Signed 20251121.pdf
  // Page 1, callout 3. Update the "Invoicing" card's "Edit" button to become disabled when the "QuickBooks Invoice #" field on the "Reference" card contains a value.
  // Maxwell Sommer 11/25/2025
  quickBooksInvoiceNumber?: string
  invoicingImportCharge?: number
  invoicingDuty?: number
  invoicingInboundTransportation?: number
  invoicingOutboundTransportation?: number
  invoicingClusterConversion?: number
  invoicingClusterProgramming?: number
  invoicingClusterReplacement?: number
  invoicingTitleFees?: number
  invoicingRecallExpenses?: number
  invoicingFedEx?: number
  invoicingFedExAPI?: number
  invoicingReplacementLabel?: number
  invoicingRepairs?: number
  invoicingVehicleCleanUp?: number
  invoicingMiscellaneous?: number
  invoicingNotes?: string
  invoicingTotal: number = 0
}

export const vehicleInvoicingValidationSchema = yup.object<VehicleInvoicingDto>({
  invoicingImportCharge: yup
    .number()
    .min(0.0, 'Import Charge cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Import Charge cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingDuty: yup.number().min(0.0, 'Duty cannot be less than $0.00.').max(999_999_999_999.99, 'Duty cannot be more than $999,999,999,999.99.').nullable(),
  invoicingInboundTransportation: yup
    .number()
    .min(0.0, 'Inbound Transportation cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Inbound Transportation cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingOutboundTransportation: yup
    .number()
    .min(0.0, 'Outbound Transportation cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Outbound Transportation cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingClusterConversion: yup
    .number()
    .min(0.0, 'Cluster Conversion cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Cluster Conversion cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingClusterProgramming: yup
    .number()
    .min(0.0, 'Cluster Programming cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Cluster Programming cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingClusterReplacement: yup
    .number()
    .min(0.0, 'Cluster Replacement cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Cluster Replacement cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingTitleFees: yup
    .number()
    .min(0.0, 'Title Fees cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Title Fees cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingRecallExpenses: yup
    .number()
    .min(0.0, 'Recall Expenses cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Recall Expenses cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingFedEx: yup
    .number()
    .min(0.0, 'FedEx cannot be less than $0.00.')
    .max(999_999_999_999.99, 'FedEx cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingReplacementLabel: yup
    .number()
    .min(0.0, 'Replacement Label cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Replacement Label cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingRepairs: yup
    .number()
    .min(0.0, 'Repairs cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Repairs cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingVehicleCleanUp: yup
    .number()
    .min(0.0, 'Vehicle Clean Up cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Vehicle Clean Up cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingMiscellaneous: yup
    .number()
    .min(0.0, 'Miscellaneous cannot be less than $0.00.')
    .max(999_999_999_999.99, 'Miscellaneous cannot be more than $999,999,999,999.99.')
    .nullable(),
  invoicingNotes: yup.string().max(2_000, 'Invoicing Notes cannot be more than 2,000 characters.').nullable()
})
